import { useEffect, useState } from "react";
import ServicesList from "./ServicesList";
import ButtonSVG from "../../../Inputs/ButtonSVG";
import UnclaimedOrEmpty from "../UnclaimedOrEmpty";

export const SERVICES_SHOW_MORE_LIMIT = 5;

const Services = ({
  services,
  split,
  expand,
  unclaimed,
  name,
  firmId,
  claimProfileUrl,
}) => {
  const [showFullListOfServices, setShowFullListOfServices] = useState(false);

  const displayedServices = showFullListOfServices
    ? services
    : services.slice(0, SERVICES_SHOW_MORE_LIMIT);

  useEffect(() => {
    if (expand !== undefined) {
      setShowFullListOfServices(expand);
    }
  }, [expand]);

  return (
    <div
      className={'pt-6 max-xs:pt-0 w-[inherit] flex flex-wrap box-border'}
      id="firmServices"
    >
      <div className={'mb-4 w-[inherit] grow-0 max-w-full'}>
        <h5 className="m-0 mb-4 max-xs:mb-6 text-2xl max-xs:text-[1.3rem] max-xs:text-center max-sm:mb-[0.15em]">
          Services
        </h5>
        {displayedServices.length >= 1 ? (
          <>
            <ServicesList services={displayedServices} />
            {services.length > SERVICES_SHOW_MORE_LIMIT && !split && (
              <ButtonSVG
                dataTest="services-expand-icon"
                onClick={() =>
                  setShowFullListOfServices(!showFullListOfServices)
                }
                expand={showFullListOfServices}
              />
            )}
          </>
        ) : (
          <div className={'mb-20'}>
            <UnclaimedOrEmpty
              text={`${name} have not provided any services yet.`}
              subtext={`Do you work at ${name}?`}
              firmId={firmId}
              linkText="Add services"
              unclaimed={unclaimed}
              claimProfileUrl={claimProfileUrl}
              utmTerm="services"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;
